import React from "react";
import PropTypes from "prop-types";

const AnalysisTableRowItem = ({
  centered,
  children,
  rowClassName,
  onClick
}) => (
  <td
    className={`${centered && "analysis-table__cell-centered"} ${rowClassName}`}
    onClick={onClick}
  >
    {children}
  </td>
);

AnalysisTableRowItem.propTypes = {
  centered: PropTypes.bool,
  rowClassName: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node
};

export default AnalysisTableRowItem;
